import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewDidEnter, ViewWillEnter } from '@ionic/angular';
import { MenuCategory, MenuItem } from 'src/app/models/rich-data.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';

@Component({
  selector: 'app-menu-section',
  templateUrl: './menu-section.component.html',
  styleUrls: ['./menu-section.component.scss'],
})
export class MenuSectionComponent implements OnInit, ViewWillEnter {
  isConcierge = false;
  reservationMode = false;
  didInit = false;
  isTypeGuestService = false;

  multiSection = false;

  selectedMenuCategory: MenuCategory = null;
  isRooms = false;
  isHaveAvailableOnDemand = false;

  bookAvailable = false;
  constructor(
    public dataServ: DataService,
    private actvrt: ActivatedRoute,
    private router: Router,
    private analytics: AnalyticsService,
    private caption: CaptionPipe,
    private authService: AuthService,
    private modalService: ModalMakerService,
    private titleService: Title
  ) {}

  async ngOnInit() {
    this.isConcierge = this.router.url.includes('/concierge');

    const SECTIONID = this.actvrt.snapshot.params.section || 116;

    if (SECTIONID === 105) {
      this.isRooms = true;
    }

    if (this.dataServ.rData?.product_type === 'guestservice') {
      this.isTypeGuestService = true;
    }

    if (SECTIONID.includes('-')) {
      const menuSectionID = SECTIONID.split('-');
      this.multiSection = true;

      this.dataServ.menuSections = [];

      // menuSectionID.forEach(async (id: string) => {
      //   this.dataServ.getSection(+id);
      //   // this.dataServ.menuSections.push(this.dataServ.menuSection);
      // });

      for (const id of menuSectionID) {
        await this.dataServ.getSection(+id);
      }
    }

    this.reservationMode = Boolean(
      this.actvrt.snapshot.queryParams.reservation
    );

    if (
      !this.dataServ.menuSection ||
      this.isConcierge ||
      this.dataServ.menuSection.id !== SECTIONID
    ) {
      if (!this.dataServ.rData) {
        this.dataServ.versionControl();
      }

      await this.dataServ.getSection(+SECTIONID);

      if (!this.dataServ.menuSection) {
        this.router.navigateByUrl('/home');
      }
    }

    console.log('this.dataServ.menuSection', this.dataServ.menuSection);
    
    this.dataServ.menuSection.menu_categories[0]?.menu_items?.forEach((item) => {
      if (item.booking_system === 'onDemand') {
        this.isHaveAvailableOnDemand = true;
        return;
      }
    });
    this.didInit = true;
  }

  ionViewWillEnter(): void {
    if (this.dataServ.menuSection && this.dataServ.menuSection.title) {
      this.titleService.setTitle(
        this.caption.transform(this.dataServ.menuSection.title, 'en')
      );
    }
  }

  selectThisCategory(menuCategory: MenuCategory) {
    if (this.dataServ.menuSection.is_grouped_by_menu_category) {
      this.selectedMenuCategory = menuCategory;
    }
  }

  backToCategoryList() {
    this.selectedMenuCategory = null;
  }

  async goToReservationPage(): Promise<void> {
    if (!this.authService.isLogged) {
      const isLoggedIn = await this.modalService.login();

      if (!isLoggedIn) {
        return;
      }
    }

    const sectionId = this.dataServ.menuSection.id;

    this.router.navigate(['/restaurant-booking'], {
      queryParams: {
        fromRestaurantListPage: true,
        sectionId: sectionId,
      },
    });
  }

  async detail(detailData: MenuItem): Promise<void> {
    await this.dataServ.getSection(detailData.menu_section_id);
    this.dataServ.getItem(detailData.id);
    this.analytics.eventEmitter(
      `${this.caption.transform(
        detailData.name,
        this.dataServ.rData.hotel_language || 'tr'
      )}`,
      'navigate',
      'route'
    );

    const MENUTAGS = this.dataServ.menuItem.tags || [];
    const hasOpenDirectUrl = MENUTAGS.some(
      (tag) => tag.name === 'open_direct_url'
    );
    const websiteUrl = this.dataServ.menuItem.web_site_url;

    if (hasOpenDirectUrl && websiteUrl) {
      window.open(websiteUrl, '_blank');
      return;
    }

    this.router.navigate([
      'home',
      this.dataServ.menuSection.id,
      detailData.id.toString(),
    ]);
  }

  canUserSee(item: MenuItem): boolean {
    if (!this.authService.profile) {
      return true;
    }

    const {
      building_id: userBuildingId,
      area_id: userAreaId,
      block_id: userBlockId,
      floor_id: userFloorId,
      section_id: userSectionId,
    } = this.authService.profile.room_info;

    if (!item.menu_item_building_filter) {
      return true;
    } else {
      switch (item.menu_item_building_filter.attribute_type) {
        case 1:
          return (
            item.menu_item_building_filter.attribute_ids.findIndex(
              (attributeId) => attributeId === userAreaId
            ) !== -1
          );
        case 2:
          return (
            item.menu_item_building_filter.attribute_ids.findIndex(
              (attributeId) => attributeId === userBlockId
            ) !== -1
          );
        case 3:
          return (
            item.menu_item_building_filter.attribute_ids.findIndex(
              (attributeId) => attributeId === userFloorId
            ) !== -1
          );
        case 4:
          return (
            item.menu_item_building_filter.attribute_ids.findIndex(
              (attributeId) => attributeId === userSectionId
            ) !== -1
          );
        default:
          return true;
      }
    }
  }
}
